module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "partbg"
  }, [_c('h2', {
    staticClass: "pn"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('h2', {
    staticClass: "pt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE SECRET WAR BEGINS")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('a', {
    staticClass: "yclr",
    attrs: {
      "href": "#/xhtml/09_Chapter1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1: COLBY’S COVERT WAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('a', {
    staticClass: "yclr",
    attrs: {
      "href": "#/xhtml/10_Chapter2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2: SWITCHING BACK—SOG IS BORN")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('a', {
    staticClass: "yclr",
    attrs: {
      "href": "#/xhtml/11_Chapter3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3: SHINING BRASS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0012-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-094dff8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Part1.vue
// module id = 84
// module chunks = 0